<template>
  <div>
    <!-- 제목 (내문서함 타이틀 변경 -> 최근신청내역(1개월))-->
    <v-row class="title-wrap fixed">
      <v-col cols="12" class="icon-title word-type pb-5"
        ><icon-my-folder :width="24" :height="24" />최근신청내역(1개월)</v-col
      >
    </v-row>

    <!-- 목록 -->
    <appl-doc-list class="overflow-y-auto" :searchReqGubun="tabGubun.tab1" />

    <!-- 탭 주석 (22.06.27 임시저장 미사용) -->
    <!-- tab  -->
    <!-- <v-tabs v-model="tab" color="primary" grow>
      <v-tab>내 문서</v-tab>
      <v-tab>임시저장문서</v-tab>
    </v-tabs> -->
    <!-- tab contents -->
    <!-- <v-tabs-items v-model="tab">
      <v-tab-item class="pt-5 px-0 pb-8">
        <appl-doc-list :searchReqGubun="tabGubun.tab1"></appl-doc-list>
      </v-tab-item>
      <v-tab-item class="pt-5 px-0 pb-8">
        <appl-doc-list :searchReqGubun="tabGubun.tab2"></appl-doc-list>
      </v-tab-item>
    </v-tabs-items> -->
  </div>
</template>

<script>
import ApplDocList from '@/components/allDoc/ApplDocList.vue';
import IconMyFolder from '@/assets/customIcon/IconMyFolder.vue';

export default {
  data: () => ({
    tab: null,
    tabGubun: {
      tab1: 'MYDOC', // 내문서
      //tab2: 'TEMP', // 임시저장문서
    },
  }),
  computed: {},
  mounted() {
    // console.log('MyBoxView.vue OK!!');
    this.$store.commit('ELA/RESET_ELA_STATE');
  },
  components: {
    ApplDocList,
    IconMyFolder,
  },
};
</script>

<style></style>
